export function normalisasiJk(nilai: unknown): string | null {
  const teks = String(nilai === null || nilai === undefined ? "" : nilai)
    .trim()
    .toUpperCase();

  if (!teks) return null;
  if (teks.charAt(0) === "L") return "L";
  if (teks.charAt(0) === "P") return "P";

  return null;
}

export function labelJk(nilai: unknown): string {
  const kode = normalisasiJk(nilai);

  if (kode === "L") return "Laki-laki";
  if (kode === "P") return "Perempuan";

  return "";
}

export const JENIS_KELAMIN_OPTIONS = [
  { value: "L", text: "Laki-laki" },
  { value: "P", text: "Perempuan" }
];
